export const useHandlers = ({ onNavigateToLogoServicesClick }) => {
    const handleBackCTAClick = () => {
        window.scrollTo(0, 0);
        onNavigateToLogoServicesClick();
    };

    return {
        handleBackCTAClick,
    };
};
